import React from 'react'
import { Link } from 'react-router-dom'
import './style.scss'
import { FormattedMessage } from 'react-intl'

const FooterAuth = ({ links, location }) => (
  <div className="footer-auth">
    <ul className="footer-link">
      {links.map((item, index) => {
        const isHttp = item?.href?.startsWith('http')
        const Tag = isHttp ? 'a' : Link
        const propsLink = isHttp ? { href: item.href, target: item.target } : { to: item.href }
        return (
          <li key={`menu-mb-${index}`} className={location.pathname === item.href ? 'active' : ''} role="presentation">
            <Tag {...propsLink} rel="noreferrer">
              <FormattedMessage id={item.label} />
            </Tag>
          </li>
        )
      })}
    </ul>
  </div>
)

export default FooterAuth
